export var PhoneNumber = function(phoneNumberData) {
    var phoneNumber = {};
    
    // Constructor
    if (phoneNumberData) {
        phoneNumber.country = phoneNumberData.country;
        phoneNumber.value = phoneNumberData.value;
    }

    // -----------------------------------------------------
    //
    //                 Public Methods
    //
    // -----------------------------------------------------
    
    // -----------------------------------------------------
    //
    //                 Private Methods
    //
    // -----------------------------------------------------
    
    return phoneNumber;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/models/phoneNumber.js
// module id = 195
// module chunks = 0